import { CustomEvents } from './CustomEvents';
import {on, emit} from './EventsBus';

class KeyboardEventsUtil {

  constructor() {
    on('keydown.ku', (data) => {
      if (data.event.type !== 'keydown') return;
      if (data.event.key && CustomEvents.KEYBOARD_EVENTS[data.event.key.toLowerCase()]) emit(CustomEvents.KEYBOARD_EVENTS[data.event.key.toLowerCase()], {eventKey : data.event.key.toLowerCase()}, false);
    });
  }

}

export default new KeyboardEventsUtil();
